export const enum HttpHeader {
	'Content-Type' = 'Content-Type',
	'Check-Origin' = 'Check-Origin',
	'Authorization' = 'Authorization',
	'x-check-token' = 'x-check-token'
}

export const enum ContentType {
	'application/x-www-form-urlencoded' = 'application/x-www-form-urlencoded',
	'application/jose' = 'application/jose'
}

export const enum HttpStatus {
	RESET_CONTENT = 205,
	UNAUTHORIZED = 401,
	FORBIDDEN = 403
}
